import axios from "axios";
import React, { useState } from "react";
// import "./Detail.css";
import { Col, Row } from "react-bootstrap";
import { FaPhone, FaUser } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
const Lipoma = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const [message, setMessage] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    // Validation (simple example)
    if (!formData.name || !formData.phone || !formData.email) {
      setMessage("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(
        "http://localhost:4000/api/send-mail",
        formData
      );
      setMessage(response.data.message || "Request sent successfully!");
    } catch (error) {
      setMessage("Failed to send the request. Please try again.");
    }
  };
  return (
    <section className="space shape-mockup-wrap">
      <div className="container">
        <div className="row">
          <div className="col-xxl-8 col-lg-7">
            <div className="page-single">
              <div className="page-meta" style={{ marginTop: "0px" }}>
                <Link className="page-tag">Lipoma Removal</Link>{" "}
              </div>
              {/* <div className="service-img">
                <img
                  src="https://html.themeholy.com/tourm/demo/assets/img/destination/destination-details.jpg"
                  alt=""
                  style={{height:'400px'}}
                />
              </div> */}
              <div className="page-content d-block">
                {/* <h2 className="box-title">
                Surgery Saathi: Expert Rhinoplasty Services in Delhi
                </h2> */}
                <h3>What is a Lipoma?</h3>
                <p className="box-text mb-30 detail-page-paraas">
                  A lipoma is a soft, fatty lump that forms under the skin.
                  These lumps are non-cancerous and generally harmless, but they
                  can grow larger over time and sometimes cause discomfort.
                  Lipomas are commonly found on areas like the shoulders, back,
                  neck, or thighs.
                </p>

                <div className="service-inner-img mb-40">
                  <img
                  src="/Images/lipomaa.jpg"
                    // src="https://img.freepik.com/premium-photo/doctor-conducting-virtual-consultation-with-patient_1280275-220305.jpg?w=900"
                    alt=""
                    style={{ height: "300px", objectFit: "cover" }}
                  />
                </div>
                <p
                  className="box-text mb-30 detail-page-paraas"
                  style={{
                    background: "aliceblue",
                    padding: "10px",
                    fontStyle: "italic",
                  }}
                >
                  Lipoma removal is done to alleviate discomfort, address
                  cosmetic concerns, or when the lipoma grows rapidly or affects
                  mobility, despite being usually benign.
                </p>
                <h2 className="box-title">Why Remove a Lipoma?</h2>
                <h4 style={{ fontSize: "18px", fontWeight: "400" }}>
                  While lipomas don’t usually pose any health risks, you may
                  want to remove them if:
                </h4>
                <div className="checklist" style={{ marginTop: "20px" }}>
                  <ul>
                    <li>The lump is large or noticeable</li>
                    <li>It causes pain or discomfort</li>
                    {/* <li>
                      Expert guide always guide you and give informations.
                    </li> */}
                    <li>It affects movement</li>
                    {/* <li>Helping all traveler for Money Exchange.</li> */}
                    <li>
                      It is located in a visible area and impacts your
                      appearance
                    </li>
                    {/* <li>Fixing a deviated septum to improve breathing</li> */}
                  </ul>
                </div>
              </div>
              {/* <p className="box-text mb-30 detail-page-paraas">
                For those seeking to enhance appearance, surgery is typically
                recommended only after nasal growth has completed, while
                functional corrections can be performed at a younger age.
              </p> */}
              {/* <div className="th-comments-wrap style2">
                <h2 className="blog-inner-title h4">
                  Rhinoplasty can be done using two main techniques:
                </h2>
                <ul className="comment-list">
                  <li className="th-comment-item">
                    <div className="th-post-comment">
                      <div className="comment-content">
                        <h3 className="name">Open Rhinoplasty:</h3>
                        <p className="text">
                          The surgeon makes a small cut between the nostrils to
                          lift the skin and reshape the nose.
                        </p>
                        <div className="reply_and_edit">
                          <i className="fa-solid fa-thumbs-up" />
                        </div>
                      </div>
                    </div>
                    <ul className="comment-list">
                      <li className="th-comment-item">
                        <div className="th-post-comment">
                          <div className="comment-content">
                            <div className="">
                              <h3 className="name">Closed Rhinoplasty:</h3>
                            </div>
                            <p className="text">
                              All cuts are made inside the nose, so no visible
                              scars remain.
                            </p>
                            <div className="reply_and_edit">
                              <i className="fa-solid fa-thumbs-up" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                 
                </ul>
              </div> */}

              <div style={{ marginTop: "50px" }}>
                <h2
                  className="box-title"
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    background: "aliceblue",
                    padding: "10px",
                  }}
                >
                  Lipoma removal is a simple surgery. A small cut is made over
                  the lump, and the fatty tissue is carefully taken out. The
                  procedure usually takes 15-30 minutes and can be done with
                  local anesthesia, which numbs the area but keeps you awake.
                  For larger or deeper lipomas, general anesthesia may be used.
                </h2>
              </div>
              {/* <div>
                <p
                  className="box-text detail-page-paraas"
                  style={{ margin: "5px" }}
                >
                  Involves a small incision at the base of the nose, providing
                  greater visibility and access for extensive reshaping. This
                  technique is ideal for significant alterations.
                </p>
                <div className="checklist" style={{ marginTop: "15px" }}>
                  <ul>
                    <li>
                      Autologous cartilage grafts taken from the nasal septum
                      (the wall inside the nose that divides one air passage
                      from the other) offers the best chance for a natural
                      result. If cartilage and bone have already been removed
                      from the nasal septum, then ear or rib cartilage and
                      sometimes bone from the skull are other options.
                    </li>
                    <li>
                      Although solid silicone implants are available for nasal
                      surgery, these are foreign materials that may become
                      infected or react poorly with the nasal tissues and have
                      to be removed. That is why natural cartilage, if a supply
                      is available, is the most trouble-free option.
                    </li>

                    <li>
                      Fillers or fat grafts may also be injected to smooth the
                      nose, to camouflage deformities or indentations, or to add
                      volume in desired areas.
                    </li>
                  </ul>
                </div>
              </div> */}
              <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Recovery</h2>
                <p
                  className="box-text detail-page-paraas"
                  style={{ margin: "5px" }}
                >
                  Recovery is usually quick and easy. You may have a small scar
                  where the incision was made, but it will fade with time. Most
                  people return to regular activities within a few days, though
                  you should avoid strenuous activities for a week or two.
                </p>
                {/* <div
                  className="procedure-checklist"
                  style={{ marginTop: "15px", listStyle: "none" }}
                >
                  <ul>
                    <li>
                      1. <b>Administration of Anesthesia:</b> The patient
                      receives either local or general anesthesia, depending on
                      the complexity of the surgery.
                    </li>
                    <li>
                      <b>2. Making Incision:</b> An incision is created, either
                      inside the nose, at the base, or between the nostrils,
                      depending on the chosen technique.
                    </li>
                    <li>
                      <b>3. Reshaping the Nose Structure:</b> The surgeon
                      readjusts the bone and cartilage underneath the skin.
                      Cartilage may be taken from within the nose, the ear, or,
                      in rare cases, the ribs, minimizing the risk of immune
                      rejection.
                    </li>
                    <li>
                      <b>4. Deviated Septum Correction:</b> If necessary, the
                      surgery corrects any crooked or deviated septum to improve
                      breathing
                    </li>
                    <li>
                      <b>5. Closing the Incision:</b> The surgeon replaces the
                      nose skin and tissue, stitching the incision closed.
                    </li>
                    <li>
                      <b>6. Applying Bandages:</b> Bandages are applied to cover
                      the treated area, supporting the healing process.
                    </li>
                    <li>
                      <b>7. Supporting Garment:</b> A splint or gauze is worn
                      for a few weeks, and patients should follow their
                      surgeon's post-operative instructions to promote healing.
                    </li>
                  </ul>
                </div> */}
              </div>
              <h2
                className="box-title"
                style={{ fontSize: "20px", margin: "10px 0px" }}
              >
                Benefits of Lipoma Removal:
              </h2>
              {/* <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Post-Operative Care</h2>
              </div> */}
              <div>
                <div className="checklist" style={{ marginTop: "15px" }}>
                  <ul>
                    <li>Eliminates discomfort or pain</li>
                    <li>Improves appearance</li>

                    <li>Quick, simple procedure with little downtime</li>
                  </ul>
                </div>
              </div>

              {/* <div style={{ marginTop: "50px" }}>
                <h2 className="box-title">Expected Results and Recovery</h2>
              </div> */}
              {/* <p
                className="box-text detail-page-paraas"
                style={{ margin: "5px" }}
              >
                Swelling generally subsides within weeks, with final results
                becoming clear over time. Most patients can return to daily
                activities within a week, while strenuous activities should be
                avoided for about two to three weeks.
              </p> */}
            </div>
          </div>
          <div className="col-xxl-4 col-lg-5">
            <aside className="sidebar-area style3">
              <div className="breakcrumbss">
                <div className="aside-detail-firstdivc">Popular Services</div>
                <ul className="detail-page-uls">
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/lipoma-removal">Lipoma Removal</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/gynaecomastia">Gynecomastia</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/rhinoplasty">Rhinoplasty</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/ophthalmology">Ophthalmology</Link>
                  </li>
                </ul>
              </div>
              <div className="breakcrumbss" style={{ marginTop: "30px" }}>
                <div className="aside-detail-firstdivc">Get Appointment</div>
                <form onSubmit={handleSubmit}>
                  <Row style={{ marginTop: "30px" }}>
                    <Col md={12} style={{ position: "relative" }}>
                      <FaUser
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="name"
                          className="aside-input-appointement"
                          placeholder="Name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <FaPhone
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="phone"
                          className="aside-input-appointement"
                          placeholder="Mobile Number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <MdEmail
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="email"
                          name="email"
                          className="aside-input-appointement"
                          placeholder="Email Id"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12}>
                      <button type="submit" className="aside-appointment-btn">
                        Get Appointment
                      </button>
                    </Col>
                  </Row>
                </form>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Lipoma;
